import React from 'react';
import './reward-item.css';
import { isLightColor } from './utils';

const RewardItem = ({
  title,
  description,
  points,
  imageUrl,
  canRedeem,
  isLoading = false,
  isDisabled = false,
  onRedeem,
  themeColors,
  pointsTerminology = 'points',
}) => {
  const isRedeemable = canRedeem !== false && !isDisabled;

  // Capitalize points terminology
  const capitalizedTerminology =
    pointsTerminology.charAt(0).toUpperCase() + pointsTerminology.slice(1);

  return (
    <div className='dashboard-reward-item'>
      <div className='dashboard-reward-item-image'>
        <img src={imageUrl} alt={title} />
      </div>
      <div className='dashboard-reward-item-content'>
        <h4 className='dashboard-reward-item-title'>{title}</h4>
        <p className='dashboard-reward-item-description'>{description}</p>
      </div>
      <div className='dashboard-reward-item-actions'>
        <div className='dashboard-redeem-button-wrapper'>
          <button
            className={`dashboard-redeem-button ${
              !isRedeemable || isDisabled ? 'disabled' : ''
            } ${isLoading ? 'loading' : ''}`}
            style={{
              backgroundColor: isLoading
                ? themeColors.mainTextColor
                : isRedeemable && !isDisabled
                ? isLightColor(themeColors.backgroundColor)
                  ? themeColors.mainTextColor
                  : themeColors.backgroundColor
                : '#ccc',
              opacity: (isRedeemable && !isDisabled) || isLoading ? 1 : 0.7,
            }}
            onClick={
              isRedeemable && !isDisabled && !isLoading ? onRedeem : undefined
            }
            disabled={!isRedeemable || isDisabled || isLoading}
          >
            {isLoading ? (
              <div className='redeem-button-loading' style={{ color: 'white' }}>
                <img
                  src={`${window.storeConfigInitial?.storageBaseUrl}/assets/loading.svg`}
                  alt='Loading...'
                  className='redeem-loading-icon'
                  style={{ filter: 'brightness(0) invert(1)' }}
                />
                <span>Redeeming...</span>
              </div>
            ) : isDisabled ? (
              'Redeem'
            ) : !canRedeem ? (
              'Redeem'
            ) : (
              'Redeem'
            )}
          </button>
        </div>
        <div className='dashboard-reward-item-points'>
          {points.toLocaleString()} {capitalizedTerminology}
        </div>
      </div>
    </div>
  );
};

export default RewardItem;
